import * as React from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { Filter } from './filter';
import { Sort } from './sort';
export var SortFilter = function (_a) {
  var loading = _a.loading,
    inDialog = _a.inDialog;
  return React.createElement(UitkLayoutGrid, {
    columns: 1
  }, React.createElement(UitkLayoutGridItem, {
    colSpan: "all",
    className: "form-truncate"
  }, React.createElement("fieldset", {
    "aria-busy": loading,
    "data-testid": "sort-filter--fieldset"
  }, inDialog && React.createElement(Sort, {
    inDialog: true
  }), React.createElement(Filter, {
    inDialog: inDialog
  }))));
};